import PropTypes from "prop-types";
import { MODAL_TEXT } from "../../ui/modalStyles";
import ModalCloseX from "../common/ModalCloseX";

export default function DeleteTicketModal({
  isOpen,
  onClose,
  onConfirm,
  isSubmitting = false,
  title = "Confirm",
  message = "Are you sure you want to delete this ticket?",
  subMessage = "This action cannot be undone.",
  detailMessage = "",
  confirmText = "Delete",
  confirmBusyText = "Deleting...",
  errorText = "",
  showInput = false,
  inputLabel = "Optional note",
  inputPlaceholder = "",
  inputValue = "",
  setInputValue = null,
  inputOptional = true,
  maxLength = 500,
}) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[10050] flex items-center justify-center bg-black/60 px-4 py-6">
      <div
        role="dialog"
        aria-modal="true"
        className={`relative w-full max-w-md h-auto max-h-[80vh] rounded-3xl border border-slate-200 bg-white shadow-2xl overflow-hidden flex flex-col ${MODAL_TEXT}`}
      >
        <div className="flex items-center justify-between bg-rose-500 px-6 py-4">
          <h2 className="text-xl md:text-2xl font-semibold text-white">
            {title}
          </h2>
          <ModalCloseX onClick={onClose} />
        </div>
        <div className="px-6 py-6 overflow-y-auto max-h-[calc(80vh-160px)]">
          {errorText ? (
            <div className="mb-4 rounded-2xl border border-rose-200 bg-rose-50 px-4 py-3 text-sm text-rose-700">
              {errorText}
            </div>
          ) : null}
          <div className="text-sm text-slate-700 space-y-2">
            {message ? <p>{message}</p> : null}
            {subMessage ? <p>{subMessage}</p> : null}
            {detailMessage ? (
              <p className="text-xs text-slate-500">{detailMessage}</p>
            ) : null}
          </div>
          {showInput ? (
            <div className="mt-4 space-y-2">
              <label className="block text-sm font-medium text-slate-700">
                {inputLabel}
                {inputOptional ? (
                  <span className="ml-1 text-xs font-normal text-slate-500">
                    (optional)
                  </span>
                ) : null}
              </label>
              <input
                type="text"
                value={inputValue ?? ""}
                onChange={(event) => {
                  if (typeof setInputValue !== "function") return;
                  setInputValue(event.target.value);
                }}
                placeholder={inputPlaceholder}
                maxLength={maxLength}
                className="w-full rounded-2xl border border-slate-300 px-4 py-3 text-sm focus:border-slate-400 focus:outline-none focus:ring-2 focus:ring-slate-900/10"
              />
            </div>
          ) : null}
        </div>
        <div className="border-t border-slate-200 px-6 py-4 flex-shrink-0">
          <div className="flex justify-end gap-2">
            <button
              type="button"
              className="rounded-full border border-slate-300 px-5 py-2 text-sm font-semibold text-slate-700 hover:bg-slate-50"
              onClick={onClose}
              disabled={isSubmitting}
            >
              Cancel
            </button>
            <button
              type="button"
              onClick={onConfirm}
              disabled={isSubmitting}
              className="rounded-full bg-rose-500 px-5 py-2 text-sm font-semibold text-white hover:bg-rose-600 disabled:opacity-60"
            >
              {isSubmitting ? confirmBusyText : confirmText}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

DeleteTicketModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool,
  title: PropTypes.string,
  message: PropTypes.string,
  subMessage: PropTypes.string,
  detailMessage: PropTypes.string,
  confirmText: PropTypes.string,
  confirmBusyText: PropTypes.string,
  errorText: PropTypes.string,
  showInput: PropTypes.bool,
  inputLabel: PropTypes.string,
  inputPlaceholder: PropTypes.string,
  inputValue: PropTypes.string,
  setInputValue: PropTypes.func,
  inputOptional: PropTypes.bool,
  maxLength: PropTypes.number,
};
